import { LearnerAppRemote } from '@/features/microFrontend/learnerMF/LearnerAppRemote'
import { useDocTitle } from '@/features/wa/title/useDocTitle'
import { useCoursesTitle } from '@/hooks/useCoursesTitle'
import styles from './CoursesMF.module.scss'

export const CoursesMF = () => {
  const title = useCoursesTitle()
  useDocTitle(title)

  return (
    <div className={styles.homeWrapper}>
      <LearnerAppRemote />
    </div>
  )
}
